"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsLoaderProvider = void 0;
const SERVICE_NOT_INITIALIZED_ERROR = 'FragmentsLoader is not initialized. Use FragmentsServiceFactory for initialization.';
class FragmentsLoaderProvider {
    static get fragmentsLoader() {
        if (!window.fragmentsLoader) {
            throw new Error(SERVICE_NOT_INITIALIZED_ERROR);
        }
        return window.fragmentsLoader;
    }
}
exports.FragmentsLoaderProvider = FragmentsLoaderProvider;
